/* POPUP */
function modal() {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      let el = this;
      let ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  const settings = {
    speedOpen: 50,
    speedClose: 150,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-modal-target]',
    selectorTrigger: '[data-modal-trigger]',
    selectorClose: '[data-modal-close]',
  };

  var toggleccessibility = function (event) {
    if (event.getAttribute('aria-expanded') === 'true') {
      event.setAttribute('aria-expanded', false);
    } else {
      event.setAttribute('aria-expanded', true);
    }
  };

  const openModal = function (trigger) {
    const target = document.getElementById(trigger.getAttribute('href').replace('#', ''));
    target.classList.add(settings.activeClass);
    document.documentElement.classList.add("training-popup--opened");
    toggleccessibility(trigger);
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  const closeModal = function (event) {
    const closestParent = event.closest(settings.selectorTarget);
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.classList.remove("training-popup--opened");
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  const clickHandler = function (event) {
    let toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    if (open) {
      openModal(open);
    }
    if (close) {
      closeModal(close);
    }
    if (open || close) {
      event.preventDefault();
    }
  };

  const keydownHandler = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      let modals = document.querySelectorAll(settings.selectorTarget),i;
      for (let i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }
    }
  };

  window.showModal = function (modalName) {
    const target = document.getElementById(modalName);
    target.classList.add(settings.activeClass);
    target.setAttribute('aria-expanded', true);
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);

  };

  window.hideModal = function (modalName) {
    const target = document.getElementById(modalName);
    target.classList.remove(settings.visibleClass);
    target.setAttribute('aria-expanded', false);
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      target.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);

};
modal();
/* END POPUP */


/* PICE FORMAT */
function formatCurrency(amount) {
    amount = amount / 100;
    const parts = amount.toFixed(2).toString().split('.');
    let dollars = parts[0];
    let cents = parts[1];
    dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + dollars + '.' + cents;
}
/* END PICE FORMAT */


/* CHANGE CHECKBOX EVENT */
const changeCheckbox = (targ) => {
  const trainingCheckbox = targ;
  const trainingPrice = trainingCheckbox.hasAttribute('data-price') ? Number(trainingCheckbox.getAttribute('data-price')) : null;
  const productPriceElement = document.querySelector('.product-main .money[data-price-value]');
  const productComparePriceElement = document.querySelector('.product-main .money[data-price-compare-value]');
  const trainingIdInputs = document.querySelectorAll('.training-product-input');
  const productIdInput = document.querySelector('.product-main .variant-selection__variants[data-variants]');
  const productQtyInput = document.querySelector('.product-main .quantity-selector__input');

  if (trainingPrice && productPriceElement) {
    const productPrice = productPriceElement.hasAttribute('data-price-value') ? Number(productPriceElement.getAttribute('data-price-value')) : null;
    const productComparePrice = productComparePriceElement.hasAttribute('data-price-compare-value') ? Number(productComparePriceElement.getAttribute('data-price-compare-value')) : null;

    if (productPrice) {
      const btnsBlock = document.querySelector('[data-shopify="payment-button"]');
      if (trainingCheckbox.checked === true) {
        productPriceElement.innerHTML = formatCurrency(productPrice + trainingPrice);
        if (productComparePriceElement) productComparePriceElement.innerHTML = formatCurrency(productComparePrice + trainingPrice);
        if (trainingIdInputs.length) {
          trainingIdInputs.forEach(input => {
            input.removeAttribute('disabled');
            if (input.classList.contains('training-product-input--props')) {
              input.value = Date.now().toString();
            }
          });

          if (productIdInput) productIdInput.setAttribute('name','items[1]id');
          if (productQtyInput) productQtyInput.setAttribute('name','items[1]quantity');
          if (btnsBlock) btnsBlock.style.display = 'none';
        }
      } else {
        productPriceElement.innerHTML = formatCurrency(productPrice);
        if (productComparePriceElement) productComparePriceElement.innerHTML = formatCurrency(productComparePrice);
        if (trainingIdInputs.length) {
          trainingIdInputs.forEach(input => input.setAttribute('disabled', 'disabled'));

          if (productIdInput) productIdInput.setAttribute('name','id');
          if (productQtyInput) productQtyInput.setAttribute('name','quantity');
          if (btnsBlock) btnsBlock.style.display = 'block';
        }
      }
    } 
  }
}


document.addEventListener('change', (e) => {
  if (!e.target) return;

  if (e.target.hasAttribute('name') && e.target.getAttribute('name') === 'training_product') {
    changeCheckbox(e.target);
  }
})
/* END CHANGE CHECKBOX EVENT */


/* CLICK POPUP EVENT */
document.addEventListener('click', (e) => {
    if (!e.target) return;

    if (e.target.classList.contains('training-product__link') && e.target.getAttribute('href') === '#training_popup') {
        e.preventDefault();
        window.showModal('training_popup');
    }
});
/* END CLICK POPUP EVENT */

document.addEventListener("DOMContentLoaded", () => {
  const trainCheck = document.querySelector('[name="training_product"]');
  if (trainCheck) {
    setTimeout(() => {
      trainCheck.checked = false;
    }, 100);
  }
})